import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-modal-help-delinquent',
  templateUrl: './modal-help-delinquent.component.html',
  styleUrls: ['./modal-help-delinquent.component.scss']
})
export class ModalHelpDelinquentComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalHelpDelinquentComponent>
  ) { }

  ngOnInit() {
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}
